import { render, staticRenderFns } from "./EmailsList.vue?vue&type=template&id=440d509e&scoped=true&"
import script from "./EmailsList.vue?vue&type=script&lang=ts&"
export * from "./EmailsList.vue?vue&type=script&lang=ts&"
import style0 from "./EmailsList.vue?vue&type=style&index=0&id=440d509e&lang=scss&scoped=true&"
import style1 from "./EmailsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440d509e",
  null
  
)

export default component.exports